// Lean, dependency-free "recently viewed" tracker.
// - Loaded site-wide (deferred) from layout/theme.liquid.
// - On any /products/{handle} page, records the handle in localStorage
//   (no server-side changes, no edits to the product template needed).
// - Exposes window.ocRenderRecentlyViewed(container, options) so any page
//   (e.g. the collection grid) can render a small "recently viewed" strip by
//   fetching each product's public .js endpoint client-side.
(function () {
  if (window.__ocRecentlyViewedInit) return;
  window.__ocRecentlyViewedInit = true;

  var KEY = 'oc-recently-viewed';
  var MAX_STORED = 12;

  function getViewed() {
    try {
      var raw = localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setViewed(handles) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {
      /* storage unavailable — fail silently */
    }
  }

  function trackCurrentProduct() {
    var match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
    if (!match) return;
    var handle = match[1];
    var handles = getViewed().filter(function (h) {
      return h !== handle;
    });
    handles.unshift(handle);
    if (handles.length > MAX_STORED) handles = handles.slice(0, MAX_STORED);
    setViewed(handles);
  }

  function formatMoney(cents) {
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var locale = document.documentElement.getAttribute('lang') || 'fr-FR';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  window.ocRenderRecentlyViewed = function (container, options) {
    if (!container) return;
    options = options || {};
    var excludeHandle = options.exclude || null;
    var max = options.max || 4;

    var handles = getViewed()
      .filter(function (h) {
        return h !== excludeHandle;
      })
      .slice(0, max);

    if (handles.length < 2) return;

    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (products.length < 2) return;

      container.innerHTML = '';
      products.forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]);
        var a = document.createElement('a');
        a.href = '/products/' + p.handle;
        a.className = 'rv-card';

        var mediaDiv = document.createElement('div');
        mediaDiv.className = 'rv-card__media';
        if (img) {
          var imgEl = document.createElement('img');
          imgEl.src = img + (img.indexOf('?') === -1 ? '?width=400' : '&width=400');
          imgEl.loading = 'lazy';
          imgEl.width = 400;
          imgEl.height = 400;
          imgEl.alt = p.title || '';
          mediaDiv.appendChild(imgEl);
        }
        a.appendChild(mediaDiv);

        var infoDiv = document.createElement('div');
        var titleEl = document.createElement('h3');
        titleEl.className = 'rv-card__title';
        titleEl.textContent = p.title;
        var priceEl = document.createElement('div');
        priceEl.className = 'rv-card__price';
        priceEl.textContent = formatMoney(p.price);
        infoDiv.appendChild(titleEl);
        infoDiv.appendChild(priceEl);
        a.appendChild(infoDiv);

        container.appendChild(a);
      });

      var section = container.closest('[data-recently-viewed-section]');
      if (section) section.hidden = false;
    });
  };

  trackCurrentProduct();
})();
